'use client'

import { EHomeCategoryTab } from '@/app/[locale]/(home)/_components/constants'
import { CategoryCarousel } from '@/components/common/category-carousel'
import { FilterButton } from '@/components/common/home/category-section/filter-button'
import { HomeContainer } from '@/components/common/home/home-container'
import { cn, normalizeSlug } from '@/lib/utils'
import { THomepageData } from '@/types/home'
import { useCallback, useMemo, useState } from 'react'

type Props = {
  homeSettingWomen?: THomepageData
  homeSettingMen?: THomepageData
  className?: string
  defaultTab?: EHomeCategoryTab
  homeType?: 'nam' | 'nu' | 'chung'
}

export const CategorySection: React.FC<Props> = ({
  homeSettingWomen,
  homeSettingMen,
  className,
  defaultTab,
  homeType,
}) => {
  const [selectedTab, setSelectedTab] = useState(
    defaultTab ?? EHomeCategoryTab.MEN
  )

  const onChangeTab = useCallback((tab: EHomeCategoryTab) => {
    setSelectedTab(tab)
  }, [])

  const categories = useMemo(() => {
    const rawCategories =
      selectedTab === EHomeCategoryTab.MEN
        ? homeSettingMen?.homepage_category
        : homeSettingWomen?.homepage_category

    return (rawCategories ?? [])
      .filter((item) => {
        const isHidden = item.hidden
        const hasImage = Boolean(item.image)

        // Điều kiện giữ lại item nếu:
        // - không ẩn và có ảnh
        // - hoặc `hidden` không rõ ràng (undefined) và có ảnh
        return isHidden !== true && hasImage
      })
      .map((item) => ({
        ...item,
        url: '/' + normalizeSlug(item.url),
      }))
  }, [selectedTab, homeSettingMen, homeSettingWomen])

  const showFilter = homeSettingWomen && homeSettingMen

  return (
    <HomeContainer className={cn('space-y-4 lg:space-y-6', className)}>
      {showFilter && (
        <FilterButton
          onChangeTab={onChangeTab}
          selectedTab={selectedTab}
          homeType={homeType}
        />
      )}

      <CategoryCarousel categories={categories} homeType={homeType} />
    </HomeContainer>
  )
}
